import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-emotion-sad-line text-3xl" />
      </span>
      <p className="mt-6 font-display text-6xl font-extrabold text-foreground-200 md:text-8xl">
        404
      </p>
      <h1 className="mt-2 text-xl font-bold text-foreground-950 md:text-2xl">
        抱歉，没有找到这个页面
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        链接：{location.pathname} 可能已失效，返回首页继续阅读韩漫吧。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          去搜索韩漫
        </Link>
      </div>
    </div>
  );
}